import "@babel/polyfill";
import '../public-path';
import { initLoggerFactory, eLogLevel, createLogger } from "@888webteam/logger-core";
import { ConsoleLoggerFactory } from "@888webteam/logger-console";

initLoggerFactory(new ConsoleLoggerFactory(eLogLevel.Debug));

import { BankIdAuthenticator } from "./BankIdAuthenticator";

window.bankIdAuthenticator = function (settings) {

    let logger = createLogger("BankIdAuthenticatorSdk");
    logger.log("using BankIdAuthenticator", VERSION);

    return new BankIdAuthenticator(settings);
}